var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 103,
    viewBox: "0 0 99 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9688 93.3438H15.4688C13.8277 93.3438 12.2539 92.6655 11.0935 91.4583C9.93315 90.251 9.28125 88.6136 9.28125 86.9062V16.0938C9.28125 14.3864 9.93315 12.749 11.0935 11.5417C12.2539 10.3345 13.8277 9.65625 15.4688 9.65625H64.9688V16.0938H15.4688V86.9062H64.9688V93.3438Z",
    fill: "#20DDA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5938 28.9688H46.4062V74.0312H52.5938V28.9688Z",
    fill: "#20DDA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7188 28.9688H83.5312V74.0312H89.7188V28.9688Z",
    fill: "#20DDA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1562 28.9688H64.9688V74.0312H71.1562V28.9688Z",
    fill: "#20DDA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 103,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetectionIcon);
export default __webpack_public_path__ + "static/media/detection-icon.3af0d85f6a566c989c6b2532ce48aaf3.svg";
export { ForwardRef as ReactComponent };